<template>
  <section class="colored section">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(validateBeforeSubmit)">
        <p>
          {{ $t('Los campos marcados con asterisco (*) son obligatorios.') }}
        </p>
        <label class="label">{{ $t('Detalles del fundador') }}</label>
        <b-field grouped group-multiline>
          <b-field expanded>
            <ValidationProvider
              name="Name"
              rules="required"
              v-slot="{ errors }"
            >
              <b-input
                expanded
                v-model="formData.founder.name"
                :placeholder="$t('Nombre')"
              ></b-input>
              <p v-show="errors.length" class="help is-danger">
                {{ $t('Nombre no válido') }}
              </p>
            </ValidationProvider>
          </b-field>
          <b-field expanded>
            <ValidationProvider
              name="Surname"
              rules="required"
              v-slot="{ errors }"
            >
              <b-input
                expanded
                v-model="formData.founder.surname"
                :placeholder="$t('Apellidos')"
              ></b-input>
              <p v-show="errors.length" class="help is-danger">
                {{ $t('Apellido no válido') }}
              </p>
            </ValidationProvider>
          </b-field>
        </b-field>

        <b-field grouped group-multiline>
          <b-field expanded :label="$t('Profesión') + '*'">
            <ValidationProvider
              name="Profession"
              rules="required"
              v-slot="{ errors }"
            >
              <b-input expanded v-model="formData.founder.profession"></b-input>

              <p v-show="errors.length" class="help is-danger">
                {{ $t('Profesión no válida') }}
              </p>
            </ValidationProvider>
          </b-field>

          <b-field expanded :label="$t('Móvil') + '*'">
            <ValidationProvider
              name="Phone"
              rules="required"
              v-slot="{ errors }"
            >
              <b-input expanded v-model="formData.founder.phone"></b-input>

              <p v-show="errors.length" class="help is-danger">
                {{ $t('Móvil no válido') }}
              </p>
            </ValidationProvider>
          </b-field>
        </b-field>

        <b-field grouped group-multiline>
          <b-field expanded :label="$t('Email') + '*'">
            <ValidationProvider
              name="Email"
              rules="required|email"
              v-slot="{ errors }"
            >
              <b-input expanded v-model="formData.founder.email"></b-input>

              <p v-show="errors.length" class="help is-danger">
                {{ $t('Email no válido') }}
              </p>
            </ValidationProvider>
          </b-field>

          <b-field expanded :label="$t('Linkedin')">
            <b-input expanded v-model="formData.founder.linkedin"></b-input>
          </b-field>
        </b-field>
        <b-field :label="$t('Dirección de la compañía')">
          <b-input
            expanded
            v-model="formData.companyAddress.address"
            :placeholder="$t('Dirección, 1')"
          ></b-input>
        </b-field>
        <b-field grouped group-multiline>
          <b-field expanded>
            <b-input
              expanded
              v-model="formData.companyAddress.city"
              :placeholder="$t('Ciudad')"
            ></b-input>
          </b-field>
          <b-field expanded>
            <b-input
              expanded
              v-model="formData.companyAddress.region"
              :placeholder="$t('Estado / Provincia / Región')"
            ></b-input>
          </b-field>
        </b-field>

        <b-field grouped group-multiline>
          <b-field expanded>
            <b-input
              expanded
              v-model="formData.companyAddress.postCode"
              :placeholder="$t('Código Postal')"
            ></b-input>
          </b-field>
          <b-field expanded>
            <b-input
              expanded
              v-model="formData.companyAddress.country"
              :placeholder="$t('País')"
            ></b-input>
          </b-field>
        </b-field>

        <b-field :label="$t('¿Cómo nos conociste?')">
          <b-input
            expanded
            v-model="formData.howMet"
            :placeholder="
              $t('Website / Red social / Buscador / Ecobanka / Otro')
            "
          ></b-input>
        </b-field>
        <b-field
          :label="$t('Información adicional que te gustaría que supiéramos')"
        >
          <b-input
            expanded
            v-model="formData.additionalInfo"
            type="textarea"
          ></b-input>
        </b-field>
        <div class="has-text-centered">
          <b-button size="is-large" native-type="submit" type="is-primary">{{
            $t('Guardar')
          }}</b-button>
        </div>
      </form>
    </ValidationObserver>
  </section>
</template>
<script>
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import {
  required,
  alpha,
  numeric,
  email,
  confirmed
} from 'vee-validate/dist/rules'

extend('required', {
  ...required
})

extend('alpha', {
  ...alpha
})

extend('numeric', {
  ...numeric
})

extend('email', {
  ...email
})

extend('confirmed', {
  ...confirmed
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    contactInfo: {
      type: Object,
      default: function() {
        return {
          founder: {
            name: null,
            surname: null,
            profession: null,
            phone: null,
            email: null,
            linkedin: null
          },
          companyAddress: {
            address: null,
            number: null,
            region: null,
            postCode: null,
            country: null
          },
          howMet: null,
          additionalInfo: null
        }
      }
    }
  },
  watch: {
    contactInfo: function(val) {
      this.formData = val
    }
  },
  beforeMount() {
    this.formData = this.contactInfo
  },
  data() {
    return {
      formData: {}
    }
  },
  methods: {
    validateBeforeSubmit() {
      this.$emit('formSubmit', { contactInfo: this.formData })
    }
  }
}
</script>

<style scoped></style>
